import styled from 'styled-components'

import { Button } from '@/components/ui/button'

export const Container = styled.div({
  alignItems: 'center',
  display: 'flex',
  gap: '0.8rem',
})

export const ApproveButton = styled(Button)(({ theme }) => ({
  '&:disabled': {
    backgroundColor: 'transparent',
    borderColor: theme.colors.green300,
    color: theme.colors.green300,
  },
  '&:hover, &:active': {
    backgroundColor: theme.colors.green500,
    borderColor: theme.colors.green500,
    color: theme.colors.white,
  },
  borderColor: theme.colors.gray500,
  color: theme.colors.green500,
}))

export const DeclineButton = styled(Button)(({ theme }) => ({
  '&:disabled': {
    backgroundColor: 'transparent',
    borderColor: theme.colors.red300,
    color: theme.colors.red300,
  },
  '&:hover, &:active': {
    backgroundColor: theme.colors.red500,
    borderColor: theme.colors.red500,
    color: theme.colors.white,
  },
  borderColor: theme.colors.gray500,
  color: theme.colors.red500,
}))
